export default __webpack_public_path__ + "media/images/lao-svg-2-e791ff8f759ace7df0fcddbad49fbfef.svg";